export default {
  root: 'Root',
  booking: {
    index: 'Booking',
    result: 'BookingResult',
    roomsRecommender: 'RoomsRecommender'
  },
  facilities: 'Facilities',
  cancellationPolicy: 'CancellationPolicy',
  reservation: {
    index: 'Reservation',
    guestDetail: 'ReservationGuestDetail',
    confirmation: 'ReservationConfirmation',
    review: 'ReservationReviewItem',
    failure: 'ReservationFailure'
  },
  search: 'SearchReservation',
  membership: {
    signOut: 'SignOut',
    signIn: 'SignIn',
    signUp: 'SignUp',
    changePassword: 'ChangePassword',
    forgotPassword: 'ForgotPassword',
    memberConfirmation: 'Confirmation',
    memberDeletedConfirmation: 'Deleted',
    resendConfirmationEmail: 'ResendConfirmationEmail',
    chatSignIn: 'chatSignIn',
    chatSignUp: 'chatSignUp',
    chatSignUpForm: 'chatSignUpForm',
    chatSignUpResult: 'ChatSignUpResult',
    chatSignUpSyncDone: 'ChatSignUpSyncDone',
    signUpResult: 'SignUpResult',
    signUpSyncDone: 'SignUpSyncDone'
  },
  organization: {
    signIn: 'OrganizationSignIn',
    admin: 'OrganizationAdmin'
  },
  myAccount: {
    profile: 'MyProfile',
    reservations: 'MyReservations',
    points: 'MyPoints',
    paymentOptions: 'paymentOptions'
  },
  iframeToken: 'IframeToken',
  triplaPay: 'TriplaPay',
  triplaPayDisplay: 'TriplaPayDisplay',
  errorPages: {
    serviceUnavailable: 'ErrorPageServiceUnavailable'
  }
}
